import { useEffect } from 'react'
import useSWR from 'swr'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import Skeleton from '@/components/ui/skeleton'
import { PRODUCT_TREE_URL } from '@/comm/product-tree'
import { useProductTreeStore } from '@/stores/product-tree-store'

/**
 * 登录后拉取当前用户可读的产品树与国家（GET /products/tree，各 scope 并集），写入 store 并刷新 comm 常量。
 * 首次加载完成前不渲染 children：comm 下的 Apps / Countries 等在此之前为空。
 * 之后 mutate([PRODUCT_TREE_URL]) 会重新拉取并原地刷新。
 */
const ProductTreeLoader = ({ children }) => {
  const { data, error, isLoading, mutate } = useSWR([PRODUCT_TREE_URL])
  const loaded = useProductTreeStore((state) => state.loaded)
  const setTree = useProductTreeStore((state) => state.setTree)

  useEffect(() => {
    if (data) setTree(data)
  }, [data, setTree])

  if (loaded) return children

  if (error && !isLoading) {
    return (
      <Alert variant="destructive" className="my-4">
        <AlertTitle>产品与国家列表加载失败</AlertTitle>
        <AlertDescription className="flex flex-col items-start gap-2">
          <span>{error.message}</span>
          <Button size="sm" variant="outline" onClick={() => mutate()}>
            重试
          </Button>
        </AlertDescription>
      </Alert>
    )
  }

  return (
    <div className="flex flex-col gap-2 py-2">
      <div className="flex gap-4">
        <Skeleton className="h-9 w-40" />
        <Skeleton className="h-9 w-40" />
        <Skeleton className="h-9 w-64" />
      </div>
      <Skeleton className="h-64 w-full" />
    </div>
  )
}

export default ProductTreeLoader
